function normalizeMimeType(contentType) {
  if (typeof contentType !== "string") {
    return void 0;
  }
  return contentType.replace(/;.*$/, "").replace(/\/(?!.*vnd\.|fhir\+).*\+/, "/").trim();
}
export {
  normalizeMimeType
};
//# sourceMappingURL=normalize-mime-type.js.map
